var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row full-width full-height"},[_c('a-q-empty-state',{attrs:{"emptyStateType":_vm.getStateType,"hasContainer":""},on:{"secondary":_vm.redirectToPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }